import { useCallback } from 'react';

import { storage } from '@/services/storage';

import { isNotNullable } from '../utils/isNotNullable';

type UseStorageReturnShape<T> = [T | undefined, (value: T) => void];

export const useStorage = <Value extends string = string>(
  name: string,
): UseStorageReturnShape<Value> => {
  const raw = storage.getItem(name);

  return [
    isNotNullable(raw) ? (raw as Value) : undefined,
    useCallback(
      (value: Value) => {
        storage.setItem(name, value);
      },
      [name],
    ),
  ];
};
